import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, EventEmitter, Pipe, PipeTransform, Renderer2,AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, UntypedFormControl, UntypedFormGroup, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common'
import { Subject, Observable, Subscription } from 'rxjs';
import { filter, skip } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Directive, HostListener } from '@angular/core';
import { trigger, state, style, transition, animate, animation } from '@angular/animations';
import { CustomerService } from '../../../services/customer.service';
import { OrdersService } from '../../../services/orders.service';
import { InventoryService } from '../../../services/inventory.service';
import { GlobalSearchService } from '../../../services/globalsearchservice.service';
import { normalizeSalesmanAllowed, resolveOrderEntryFiltersAutoOpen } from '../../../classes/default-salesman-allowed';
import { GlobalsService } from '../../../services/globals.service';
import { UsersService } from '../../../services/users.service';
import { FiltersService } from '../../../services/filters.service';

import { OmsService } from '../../../services/oms.service';
import { MatTableDataSource } from '@angular/material/table';
import { PurchasingService } from 'app/services/purchasing.service';
import { SpeechRecognitionService, SpeechRecognitionResult } from '../../../services/speech-recognition.service';
import * as XLSX from 'xlsx';
import { NgxDropzoneChangeEvent } from 'ngx-dropzone';
import {
	PO_UPLOAD_ALLOWED_EXTENSIONS,
	PO_AVAILABLE_FIELD_TYPES,
	applyGreedyPoAutoMap,
	buildPoUploadLineInputs,
	comparePoUploadQuantity,
	downloadPoUnmatchedMappedXlsx,
	getPoMatchOnMfgFromMappings,
	parsePoUploadSpreadsheet,
	poItemIdentificationHint,
	poUploadFieldTypeLabel,
	poUploadHasRequiredMappings,
	poUploadResolveItemIdentification,
	readFileAsArrayBuffer,
} from './po-upload-spreadsheet.util';


@Component({
	selector: 'app-item-search',
	templateUrl: './item-search.component.html',
	styleUrls: ['./item-search.component.scss'],
	animations: [
		trigger('cinfo', [
			transition(':enter', [
				animate('50ms', style({ opacity: 1, height: 100 })),
			]),
			transition(':leave', [
				animate('100ms', style({ opacity: 1, height: 0 }))
			]),
		]),
		trigger('itemSearch', [
			transition(':enter', animation([style({ transform: 'translate(-800px,0)', }),
				animate('0.2s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(1200px,0)', })
				),
			])),
		]),
		trigger('addFilters', [
			transition(':enter', animation([style({ transform: 'translate(-200px,0)', }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(0)', })
				),
			])),
			transition(':leave', animation([style({ transform: 'translate(0)' }),
				animate('0.15s cubic-bezier(0.59, 0.32, 0.38, 1.13)',
					style({ transform: 'translate(-200px,0)', })
				),
			])),
		]),
	],
})
export class ItemSearchComponent implements OnInit, OnChanges, OnDestroy {

	@Input() customer: any = false;
	@Input() isdriver: any = false;
	@Input() type: any = '10';
	@Output() addItem = new EventEmitter < any > ();
	@Output() addMix = new EventEmitter < any > ();
	@Output() addEdu = new EventEmitter < any > ();
	@Output() updateCart = new EventEmitter < any > ();
	@Output() flipToReview = new EventEmitter < any > ();

	config: any = [];
	/** PO grid quick entry: on-hand column when site shows live inventory. */
	showGridPoOnHandColumn(): boolean {
		const c = this.config;
		return !c || typeof c !== 'object' || Array.isArray(c) || c.liveinventory !== false;
	}
	itemSearchForm: UntypedFormGroup;
	search_customer_items = new UntypedFormControl(false)
	search_vendor_items = new UntypedFormControl(false)
	search_part_only = new UntypedFormControl(false)
	filters: any = [];
	screenHeight: number;
	screenWidth: number;
	regclass: any = false;
	showdetail: any = false;

	limits = [
		{ name: '25', value: '25' },
		{ name: '50', value: '50' },
		{ name: '100', value: '100' },
		{ name: '200', value: '200' },
		{ name: '300', value: '300' },
		{ name: '500', value: '500' },
		{ name: 'No Limit', value: false },
	];

	sorts = [
		{ name: 'All Availability, Sell Low To High', value: 'avail.sell|ASC' },
		{ name: 'All Availability, Sell High To Low', value: 'avail.sell|DESC' },
		{ name: 'Local Availability, Sell Low To High', value: 'local.sell|ASC' },
		{ name: 'Local Availability, Sell High To Low', value: 'local.sell|DESC' },
		{ name: 'Sell Low To High', value: 'price|ASC' },
		{ name: 'Sell High To Low', value: 'price|DESC' },
		{ name: 'Name ASC', value: 'description|ASC' },
		{ name: 'Name DESC', value: 'description|DESC' },
		{ name: 'SKU ASC', value: 'stockid|ASC' },
		{ name: 'SKU DESC', value: 'stockid|DESC' },
	];

	showGuide = false;
	showfilters = false;
	showSalesmanFilters = false;
	searching = false;
	addingitems = false;
	inventorysearching: any = false;
	filtered_items: any = [];
	purchase_items: any = [];
	item_details: any = [];
	previous_search = '';
	salesman: any = false;
	//modal
	selecteditem: any = false
	itemhistory: any = false;
	editing_order: any = false;
	user: any = [];
	expanded_rows: any = [];
	promo: any = false;
	showorder = false;
	orderdetails: any = false;
	searched: any = false;

	po_upload_button: any = false;
	allow_grid_entry: any = false;
	isGridView = false;
	editsallowed: any = {
		discounts: true,
		editar: true,
		editbilling: true,
		editshipping: true,
		editcontact: true,
		editprofile: true,
		editnotes: true,
		takepayment: true,
	}


	shownonstock = false;

	@ViewChild('purchasedetails') purchasedetails: ElementRef;
	@ViewChild('orderdetailsModal') orderdetailsModal: ElementRef;
	@ViewChild('itemHistoryRef') itemHistoryRef: ElementRef;
	@ViewChild('configproductele') configproductele: ElementRef;
	@ViewChild('nonstock') nonstockref: ElementRef;
	@ViewChild('mmmodal') mmodalref: ElementRef;
	@ViewChild('uploadpo') uploadporef: ElementRef;
	@ViewChild('itemdetails') itemDetails: ElementRef;
	@ViewChild('itemsearch') itemsearchRef: ElementRef;
	@ViewChild('resultContainer') resultContainerRef: ElementRef;
	@ViewChild('custnotesModal') custnotesModal: ElementRef;
	@ViewChild('custnotebutton') custnotebutton: ElementRef;
	@ViewChild('gridpo') gridporef: ElementRef;


	files: any = [];
	griditems: any = [];
	inputdata: any = false;
	poUploadColumns: string[] = ['stockid', 'description', 'manufacturer', 'line', 'vendor', 'min', 'max', 'qty', 'price'];
	/** Tab 0 = spreadsheet, 1 = PDF (Anthropic). */
	poImportTabIndex = 0;
	poPdfFile: File | null = null;
	poPdfDropzoneFiles: File[] = [];
	/** After AI PDF import, review tables show the extracted item code column. */
	poPdfReviewActive = false;
	/** Stable row ids for unrecognized lines (manual match UI). */
	poUploadRowIdSeq = 0;
	poManualMapStockId: Record<number, string> = {};
	/** Same as last bulk `buildpo` request — used when user manually resolves a line. */
	poLastUploadMatchOnMfg = false;
	poManualResolvingRowId: number | null = null;
	uploaddata: any = false;
	processing_recs = false;
	poDataSource: any = false;
	poReviewReady = false;
	vendors_detected: any = false;
	uploadPodata: any = false;
	from_reorder = false;
	poHelp = false;
	upload_error: any = false;
	issalesman = false;
	custNotes: any = false;

	poExcelWorkbook: XLSX.WorkBook | null = null;
	poSheetNames: string[] = [];
	poSelectedSheetName = '';
	poHeaderRowNumber = 1;
	poShowParseOptions = false;
	poActiveFile: File | null = null;
	poUploadedHeaders: string[] = [];
	poUploadedRawData: Record<string, string>[] = [];
	poColumnMappings: { [header: string]: string } = {};
	poUploadReady = false;
	poAvailableFieldTypes: string[] = [...PO_AVAILABLE_FIELD_TYPES];

	filterDefs: any[] = [];

	// Sort state properties
	sortColumn = '';
	sortDirection: 'asc' | 'desc' = 'asc';

	// Speech recognition properties
	enableVoiceSearch = localStorage.getItem('itemSearchVoiceEnabled') === 'true';
	isVoiceSearching = false;
	voiceSearchSubscription: Subscription | null = null;
	voiceErrorSubscription: Subscription | null = null;
	voiceListeningSubscription: Subscription | null = null;
	excluded_brands: any = [];
	private locationSubscription: Subscription | null = null;
	private salesmanOrderEntryFiltersBootstrapped = false;

	constructor(private inventoryService: InventoryService, private route: ActivatedRoute, private customerService: CustomerService, private orderService: OrdersService, private location: Location, public router: Router, public cdr: ChangeDetectorRef, private globalSearchService: GlobalSearchService, public omsService: OmsService, private globalsService: GlobalsService, private fb: UntypedFormBuilder, private modalService: NgbModal, public usersService: UsersService, private renderer: Renderer2, private purchasingservice: PurchasingService, public speechRecognitionService: SpeechRecognitionService, private filtersService: FiltersService) {

		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.user = this.globalSearchService.user;
			if (this.issalesman) {
				this.editsallowed = normalizeSalesmanAllowed(r.salesmanAllowed);
			}
			this.bootstrapSalesmanOrderEntryFiltersIfReady();

			this.globalSearchService.user.subscribe(u => {

				if (u.user.group_level === 2) {
					this.shownonstock = true;
				}

				if (u.user.issalesman) {
					this.issalesman = true;
					this.editsallowed = normalizeSalesmanAllowed(this.config?.salesmanAllowed);
					this.bootstrapSalesmanOrderEntryFiltersIfReady();
					if(u.user.salesman != ''){
						this.globalsService.getLuxuryManufacturers(u.user.salesman).subscribe((luxBrands =>{
							if(Array.isArray(luxBrands)  && luxBrands.length){
								this.excluded_brands = luxBrands.map((b)=>{
									if(b.granted == 0 || !b.granted){
										return b.manufacturer_id;
									}
								}).filter(Boolean)
							}
						}))
					}
				}
			})
		});

		this.locationSubscription = this.globalSearchService.selectedlocation.pipe(
			skip(1),
			filter((loc) => !!loc && this.filtered_items?.length > 0)
		).subscribe((newLoc: string) => {
			this.filtered_items.forEach((item: any) => {
				if (item.qoh && Array.isArray(item.qoh)) {
					const match = item.qoh.find((loc: any) => loc.loccode === newLoc);
					item.locqoh = match ? (match.quantity < 0 ? 0 : match.quantity) : 0;
				}
			});
			this.cdr.markForCheck();
		});

		this.getScreenSize();
	}

	@HostListener('document:keydown.escape', ['$event'])
	onSalesmanFilterEscape(event: KeyboardEvent): void {
		if (this.showSalesmanFilters) {
			event.preventDefault();
			this.closeSalesmanFilters();
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		// if(changes){
		// 	this.getCustomerNotes();
		// }
	}

	ngOnInit(): void {

		this.filtersService.getFilters().subscribe((results: any) => {
			this.filterDefs = results || [];
		});

		if (this.type == '11') {
			this.search_customer_items.setValue(true);
		}

		if (this.type == '21') {
			this.search_vendor_items.setValue(false);
			this.search_part_only.setValue(false);
			this.po_upload_button = true;
			this.allow_grid_entry = true;
		}

		if (this.user.value.user.salesman != '') {
			this.salesman = this.user.value.user.salesman;
		}

		// Load persisted sort state
		this.loadSortState();

		switch (this.config.env.package) {
		case 'beauty':
			this.itemSearchForm = this.fb.group({
				keywords: ['', Validators.required],
				limit: [this.limits[3].value, Validators.required],
				sort: [this.sorts[8].value, Validators.required],
			});


			break;
		default:
			this.itemSearchForm = this.fb.group({
				keywords: ['', Validators.required],
				limit: [this.limits[2].value, Validators.required],
				sort: [this.sorts[2].value, Validators.required],
			});

			if (this.isdriver) {
				this.itemSearchForm = this.fb.group({
					keywords: ['', Validators.required],
					limit: [this.limits[0].value, Validators.required],
					sort: [this.sorts[6].value, Validators.required],
				});
			}
			this.search_vendor_items.setValue(true);
			break;
		}
	}

	customerAllowedInvoice() {
		let allowed = true;
		if (this.customer.dissallowinvoices && this.customer.dissallowinvoices != '0' && this.config.arhold == true) {
			allowed = false;
		}
		return allowed;
	}

	@HostListener('window:resize', ['$event'])
	getScreenSize(_event?: Event): void {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
	}

	showPurchases(stockidid: any) {

	}

	runFunction(newvalue: any) {
		this.itemSearchForm.get('keywords').setValue(newvalue);
		this.itemSearch();
	}
	selectedClass(event: any){
		this.regclass = event;
	}
	openCustNotes(e:Event){
		// 		this.getCustomerNotes();
		// 		this.modalService.open(this.custnotesModal, { ariaLabelledBy: 'modal-title', size: 'lg', animation: false }).result.then((result: any) => {
		//
		// 		}, (reason) => {
		// 			this.globalSearchService.blurInputElement(this.custnotebutton);
		// 		});
	}

	getCustomerNotes(){
		const data = {
			debtorno : this.customer.debtorno,
			branch: this.customer.branchcode
		}
		this.customerService.getCustomerNotes(data).subscribe(notes => {
			this.custNotes = notes.filter(note => note.note_code === 'ORDER');
		});

	}

	addNonStock(event: any) {
		const item = event;
		const data = { item: item, debtorno: this.customer.debtorno, branchcode: this.customer.branchcode }


		this.orderService.addNonStock(data).subscribe((results: any) => {
			this.updateCart.emit(results);
			this.globalSearchService.showNotification(item.description + ' x ' + item.qty + ' Added', 'success', 'bottom', 'right');
		});
	}

	triggerMm(item: any) {
		const data = {
			stockid: item.stockid,
			qty: item.quantity,
		}

		this.inventoryService.getPromo(data).subscribe(r => {
			this.promo = r;
			this.promo.itemdesc = item;
			this.promo.qty = r.qty
			this.modalService.open(this.mmodalref, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result: any) => {

			}, (reason) => {
				this.promo = false;
				this.selecteditem = false;
			});
		})
	}

	ngAfterViewInit(): void {
		if (this.itemsearchRef && !('ontouchstart' in window)) {
			this.itemsearchRef.nativeElement.focus();
		}
	}

	private focusKeywordsInput(): void {
		const el = this.itemsearchRef?.nativeElement as HTMLInputElement | undefined;
		if (!el) {
			return;
		}
		setTimeout(() => {
			el.focus();
		}, 0);
	}

	itemSearch() {

		const keywords = this.itemSearchForm.get('keywords').value;

		let proceed = false;

		if (!this.filters.length && keywords == '') {
			proceed = false;
		} else {
			if (this.filters.length || keywords != '') {
				proceed = true;
			}
		}

		if (proceed) {

			this.globalSearchService.hideSideBar();
			this.searching = true;
			this.addingitems = true;

			this.filtered_items = [];

			if (this.inventorysearching) {
				this.inventorysearching.unsubscribe()
			}

			const data = {
				keywords: keywords,
				limit: this.itemSearchForm.get('limit').value,
				sort: this.itemSearchForm.get('sort').value,
				customer: this.customer,
				filters: this.filters,
				customer_items_only: this.search_customer_items.value,
				vendor_items_only: this.search_vendor_items.value,
				search_part_only: this.search_part_only.value,
				type: this.type,
				user: this.user._value.user
			};


			this.inventorysearching = this.orderService.getItemSearch(data).subscribe((items: any) => {
				const list = Array.isArray(items) ? items : [];
				this.filtered_items = list;
				this.searched = true;
				this.searching = false;
				if (this.sortColumn && this.filtered_items.length > 0) {
					this.applySort();
				}
				if (list.length) {
					if (!this.showfilters) {
						// this.itemSearchForm.get('keywords').setValue('');
					}
					if (this.itemsearchRef) {
						this.globalSearchService.blurInputElement(this.itemsearchRef);
					}
				} else {
					this.focusKeywordsInput();
				}
				this.cdr.markForCheck();
			});
		} else {
			this.searching = false;
		}
	}

	expand_row(index) {
		this.expanded_rows.includes(index) ? this.expanded_rows.splice(this.expanded_rows.indexOf(index), 1) : this.expanded_rows.push(index);

	}

	isExpanded(index) {
		return this.expanded_rows.includes(index);
	}


	getLineTotal(item: any): number {
		let qty = item.quantity
		if (!qty || item.quantity == 0) {
			qty = 1;
		}

		if (this.config.env.package == 'beauty') {
			// Round the LINE, not the unit: rounding the per-unit discount and then
			// multiplying by qty compounds a half-cent into whole cents, which left
			// debtortrans.ovamount adrift from the line-rounded sales/discount GL postings.
			const lineGross = this.financial(qty) * this.financial(item.price);
			var value = this.financial(lineGross) - this.financial(lineGross * this.getItemDiscountMultiplier(item));
		} else {
			//removed discount - handled on php side in $this->shop->getAlternateCustPrice
			var value = (this.financial(qty) * (this.financial(item.price)) + this.financial(item.fetvalue))
		}

		return value;

	}
	
	getGridLineTotal(item: any): number {
		let qty = item.quantity
		if (!qty || item.quantity == 0) {
			qty = 0;
		}

		if (this.config.env.package == 'beauty') {
			// Round the LINE, not the unit: rounding the per-unit discount and then
			// multiplying by qty compounds a half-cent into whole cents, which left
			// debtortrans.ovamount adrift from the line-rounded sales/discount GL postings.
			const lineGross = this.financial(qty) * this.financial(item.unitprice);
			var value = this.financial(lineGross) - this.financial(lineGross * this.getItemDiscountMultiplier(item));
		} else {
			//removed discount - handled on php side in $this->shop->getAlternateCustPrice
			var value = (this.financial(qty) * (this.financial(item.unitprice)) + this.financial(item.fetvalue))
		}

		return value;

	}

	financial(x) {

		if (Number.isNaN(x)) {
			x = 0
		}

		return parseFloat(Number.parseFloat(x).toFixed(2));
	}

	private normalizeFilters(raw: any[]): { filter_id: number; value: any }[] {
		if (!raw || !raw.length) return [];
		const seen = new Set<number>();
		const result: { filter_id: number; value: any }[] = [];
		raw.forEach((f: any) => {
			if (!f || f.filter_id === undefined || f.filter_id === null) return;
			const val = f.value;
			if (val === undefined || val === null || val === '' || val === 'reset') return;
			if (Array.isArray(val) && val.length === 0) return;
			if (seen.has(f.filter_id)) return;
			seen.add(f.filter_id);
			result.push({ filter_id: f.filter_id, value: val });
		});
		return result;
	}

	updateFilters(event: any): void {
		this.filters = this.normalizeFilters(event);
		this.buildActiveFilterChips();
	}

	onItemFiltersSelected(event: any): void {
		this.updateFilters(event);
	}

	onFilterSearchRequested(): void {
		if (this.issalesman && this.showSalesmanFilters && !this.salesmanBeautyInlineFilters) {
			this.closeSalesmanFilters();
		}
		this.itemSearch();
	}

	/** Salesman + beauty: filters render as a horizontal toolbar above results (not the left drawer). */
	get salesmanBeautyInlineFilters(): boolean {
		return !!(this.issalesman && this.config?.env?.package === 'beauty');
	}

	private bootstrapSalesmanOrderEntryFiltersIfReady(): void {
		if (!this.issalesman || !this.config || this.salesmanOrderEntryFiltersBootstrapped) {
			return;
		}
		this.showSalesmanFilters = resolveOrderEntryFiltersAutoOpen(this.config, this.config.salesmanAllowed);
		this.salesmanOrderEntryFiltersBootstrapped = true;
	}

	onItemFiltersClearAll(): void {
		this.filters = [];
		this.buildActiveFilterChips();
		this.itemSearch();
	}

	clearAllFilterChips(): void {
		this.filters = [];
		this.buildActiveFilterChips();
		this.itemSearch();
	}

	_activeFilterChips: { filterId: number; label: string; value: string; displayValue: string }[] = [];

	buildActiveFilterChips(): void {
		if (!this.filters || !this.filterDefs) {
			this._activeFilterChips = [];
			return;
		}
		const chips: { filterId: number; label: string; value: string; displayValue: string }[] = [];
		this.filters.forEach((f: any) => {
			if (!f || !f.filter_id) return;
			const def = this.filterDefs.find((d: any) => d.filter_id == f.filter_id);
			const name = def ? def.name : `Filter ${f.filter_id}`;
			const val = f.value;
			if (Array.isArray(val)) {
				val.forEach((v: any) => {
					const optLabel = def?.options?.find((o: any) => o.value == v.value)?.label ?? v.value;
					chips.push({ filterId: f.filter_id, label: name, value: v.value, displayValue: `${name}: ${optLabel}` });
				});
			} else if (val !== undefined && val !== null && val !== '') {
				const optLabel = def?.options?.find((o: any) => o.value == val)?.label ?? val;
				chips.push({ filterId: f.filter_id, label: name, value: val, displayValue: `${name}: ${optLabel}` });
			}
		});
		this._activeFilterChips = chips;
	}

	removeFilterChip(chip: { filterId: number; value: string }): void {
		const idx = this.filters.findIndex((f: any) => f && f.filter_id == chip.filterId);
		if (idx === -1) return;
		const existing = this.filters[idx];
		if (Array.isArray(existing.value)) {
			existing.value = existing.value.filter((v: any) => v.value !== chip.value);
			if (existing.value.length === 0) {
				this.filters.splice(idx, 1);
			}
		} else {
			this.filters.splice(idx, 1);
		}
		this.buildActiveFilterChips();
		this.itemSearch();
	}

	clearSearch(event: any) {
		this.itemSearchForm.get('keywords').setValue('');
	}


	updateItem(data: any) {
		const itemdata = this.filtered_items.filter((item: any) => {
			return data.item.stockid == item.stockid
		})[0]

		const index = this.filtered_items.indexOf(itemdata);
		this.filtered_items[index] = itemdata;
	}

	addPromo(item: any) {
		const data = {
			stockid: item.stockid,
			qty: item.quantity,
		}

		this.inventoryService.getPromo(data).subscribe(r => {
			this.promo = r;
			this.promo.itemdesc = item;
			this.promo.qty = r.qty
			this.addMM(this.promo);
		})
	}

	getNumberOfNonType1Intros(intros): number {
		let count = 0;
		for (const intro of intros) {
			if (intro.type !== '1' && intro.type !== 1) {
				count++;
			}
		}
		return count > 0 ? count : 1;
	}

	addMM(intro: any) {
		//test kit first
		this.addMix.emit(intro);
		this.modalService.dismissAll();
	}

	setParent(event: any, parent: any) {
		parent.qty = event.target.value;
		//multiply base values by current
		parent.intros.forEach((intro: any) => {
			intro.floor = intro.original_floor
			intro.floor = intro.floor * parent.qty;
			this.updateMMQty(intro);
		})

	}

	updateMMQty(mm: any) {
		mm.error = true;
		const items = (mm.items) ? mm.items : []

		const used = items.reduce(function(accumulator, item) {
			return accumulator + parseFloat(item.quantity);
		}, 0);

		let value = this.financial(mm.floor) - this.financial(used);

		if (value < 0) {
			mm.error = true;
			items.forEach((i: any) => {
				i.quantity = 0;
			});
			value = 0;

			this.globalSearchService.showNotification('Error, Total Qty Adjusted Items Zeroed', 'danger', 'bottom', 'right')
			//reduced down to below. e.g. changed parent to 2 and added 2 then moved back down to 1
			//remove all qtys.

		} else {
			mm.error = true;
			if (value == 0) {
				mm.error = false;
			}
		}

		return value;
	}


	decrementmm(item: any, intro: any) {
		if (item.quantity > 0) {
			item.quantity -= 1;
			this.updateMMQty(intro);
		}
	}

	incrementmm(item: any, intro: any) {
		if (this.updateMMQty(intro) > 0) {
			item.quantity += 1;
			this.updateMMQty(intro);
		} else {
			this.globalSearchService.showNotification('Promo Requirements Filled', 'danger', 'bottom', 'right')
		}
	}

	qtyMM(event: any, item: any, intro: any) {
		const original_qty = item.quantity;

		let qty_used = this.financial(event.target.value);
		const test_qty = parseFloat(original_qty) + parseFloat(event.target.value);
		const maxqty = this.updateMMQty(intro);

		if (test_qty > maxqty) {
			qty_used = maxqty;
			this.globalSearchService.showNotification('Maximum of ' + qty_used + ' Allowed', 'danger', 'bottom', 'right')
		}

		item.quantity = qty_used
		this.updateMMQty(intro);

	}

	decrement(item: any) {
		const index = this.filtered_items.indexOf(item);
		if (this.config.env.package == 'tires') {
			if (this.filtered_items[index].quantity > 0) {
				this.filtered_items[index].quantity -= 1;
			}
		} else { //allowing negartives
			this.filtered_items[index].quantity -= 1;
		}
	}

	increment(item: any) {
		const index = this.filtered_items.indexOf(item);
		this.filtered_items[index].quantity += 1;
	}

	updateSearchPrice(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);
		if (!isNaN(this.financial(item.price))) {
			this.filtered_items[index].price = this.financial(event.target.value);
		}
	}

	updateSearchQuantity(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);
		this.filtered_items[index].quantity = event.target.value;
	}

	getItemDiscountMultiplier(item) {
		if (!isNaN(this.financial(item.discount))) {
			return this.financial(item.discount / 100);
		}
		return 0;
	}

	updateSearchDiscount(event: any, item: any) {
		const index = this.filtered_items.indexOf(item);

		if (!isNaN(this.financial(event.target.value))) {
			this.filtered_items[index].discount = this.financial(event.target.value);
			if (this.filtered_items[index].discount != 0) {
				this.filtered_items[index].hasdiscount = true;
			} else {
				this.filtered_items[index].hasdiscount = false;
			}
		}
	}


	addToOrder(item: any) {
		const copyOfItems = Object.assign([], this.filtered_items);
		let this_index = '';

		this_index = this.filtered_items.indexOf(item)
		if (!copyOfItems[this_index].quantity) {
			copyOfItems[this_index].quantity = 1;
		}


		const allow = true;

		if (this.isdriver) {
			if (copyOfItems[this_index].quantity > copyOfItems[this_index].max_credit) {
				alert('Maximum Qty Credit ' + copyOfItems[this_index].max_credit + ' for ' + copyOfItems[this_index].stockid + ' Reached, call main office.');
				copyOfItems[this_index].quantity = 0;
				return false;
			}
		}

		const add_items = [];

		copyOfItems.forEach((items: any, index) => {
			items.allownegative = true;
			items.isnegative = false;

			if (this.type == '21') {

				const qty_request = parseFloat(items.quantity);
				if (qty_request != 0) {
					const qty_min = parseFloat(items.minorderqty);
					const qty_max = parseFloat(items.maxorderqty);

					const qty_max_stock = parseFloat(item.minmax.maximum);
					const qty_min_stock = parseFloat(item.minmax.minimum);

					if (qty_min > 0 && qty_max > 0) {
						if (qty_request > qty_max) {
							// allow = confirm('Attempting to Purchase more than '+qty_max+' for '+items.description+', procced?');
						}

						if (qty_request < qty_min) {
							// allow = confirm('Attempting to Purchase less than '+qty_min+' for '+items.description+', procced?');
						}
					}

					if (allow) {
						if (qty_max_stock > 0 && qty_max_stock > 0) {
							if (qty_request > qty_max_stock) {
								// allow = confirm('Attempting to Purchase more than '+qty_max_stock+' for '+items.description+', procced?');
							}

							if (qty_request < qty_min_stock) {
								// allow = confirm('Attempting to Purchase less than '+qty_min_stock+' for '+items.description+', procced?');
							}
						}
					}
				}
			}
			if (allow) {
				if (parseFloat(items.quantity) != 0) {
					add_items.push(items);
				}
			}

		});

		this.addItem.emit(add_items);
		this.filtered_items.forEach(i => { i.quantity = 0; });

	}

	addMultipleToOrder() {
		this.filtered_items.forEach(element => {
			element.quantity > 0 ? this.addToOrder(element) : '';
		});
	}

	setPurchOrderOptions(cart_id: any, selected: any) {
		const data = { cart_id: cart_id, options: selected }
		this.orderService.setPoOptions(data).subscribe((results: any) => {
			this.modalService.dismissAll();
			this.purchase_items = [];
		});

		this.updateCart.emit(true);
	}


	//modals
	viewitemOrderHistory(item: any) {
		this.selecteditem = item;
		this.customerService.getCustomerHistoryItem(this.customer.debtorno, item.stockid).subscribe((result: any) => {
			this.itemhistory = result
			this.inventoryService.getPurchaseHistory(item.stockid).subscribe(async (result: any) => {
				this.itemhistory.purchase = result;
			})

			this.modalService.open(this.itemHistoryRef, { ariaLabelledBy: 'modal-title', size: 'xl', animation: false }).result.then((result: any) => {

			}, (reason) => {
				this.itemhistory = [];
				this.selecteditem = false;
			});
		});
	}

	viewPurchOrderOptions(line: any) {
		line.allownegative = true;
		const data = { cart_id: line.cart_id, stockid: line.stockid }
		this.orderService.getPurchDataFromLine(data).subscribe((results: any) => {
			this.purchase_items.push(results);
			this.modalService.open(this.purchasedetails, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result: any) => {

			}, (reason) => {
				this.purchase_items = [];
			});
		});
	}

	loadOrder(order) {
		this.orderService.getOrderInqSearch(order).subscribe((results: any) => {
			this.showorder = true;
			this.orderdetails = results[0];


			this.modalService.open(this.orderdetailsModal, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then((result) => {

			}, (reason) => {

			});

		});
	}

	openModal(content, item) {

		this.item_details = item;
		this.modalService.open(content, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.item_details = false;
		});
	}

	toggleFilters() {
		this.showfilters = !this.showfilters;
	}

	toggleSalesmanFilters(): void {
		this.showSalesmanFilters = !this.showSalesmanFilters;
	}

	closeSalesmanFilters(): void {
		this.showSalesmanFilters = false;
	}

	toggleGuide() {
		this.showGuide = (this.showGuide) ? false : true;
	}

	open_po_upload() {
		this.modalService.open(this.uploadporef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			this.uploadPodata = [];
			this.files = [];
			this.resetUploadPo();
			this.upload_error = false;
		});
	}

	get poUploadReviewColumns(): string[] {
		if (!this.poPdfReviewActive) {
			return this.poUploadColumns;
		}
		const out: string[] = [];
		for (const c of this.poUploadColumns) {
			out.push(c);
			if (c === 'stockid') {
				out.push('doc_sku');
			}
		}
		return out;
	}

	get poUnrecognizedReviewColumns(): string[] {
		return [...this.poUploadReviewColumns, 'map_sku'];
	}

	exportUnmatchedPoLinesToXlsx(): void {
		const bad = this.poDataSource?.['bad']?.data as Record<string, unknown>[] | undefined;
		if (!bad?.length) {
			this.globalSearchService.showNotification('No unmatched lines to export.', 'info', 'bottom', 'right');
			return;
		}
		const ok = downloadPoUnmatchedMappedXlsx({
			badRows: bad,
			poPdfReviewActive: this.poPdfReviewActive,
			poUploadedHeaders: this.poUploadedHeaders,
			poColumnMappings: this.poColumnMappings,
			filenameBase: this.poPdfReviewActive ? 'po-unmatched-pdf' : 'po-unmatched',
		});
		if (ok) {
			this.globalSearchService.showNotification('Unmatched lines exported to Excel.', 'success', 'bottom', 'right');
		}
	}

	private assignPoUploadRowIds(rows: any[] | null | undefined): void {
		if (!rows?.length) {
			return;
		}
		for (const r of rows) {
			if (r._poRowId == null) {
				r._poRowId = ++this.poUploadRowIdSeq;
			}
		}
	}

	private recalculatePoUploadPodataFromDataSources(): void {
		if (!this.uploadPodata) {
			return;
		}
		const good = this.poDataSource['good']?.data || [];
		const bad = this.poDataSource['bad']?.data || [];
		this.uploadPodata.items = good;
		this.uploadPodata.lines.good = good.length;
		this.uploadPodata.lines.bad = bad.length;
		this.uploadPodata.units.good = good.reduce((s, i) => s + Number(i.quantity || 0), 0);
		this.uploadPodata.units.bad = bad.reduce((s, i) => s + Number(i.quantity || 0), 0);
	}

	private mergeResolvedPoLineIntoGood(goodLine: any, badRow: any): void {
		const badData = [...(this.poDataSource['bad']?.data || [])];
		const idx = badData.findIndex((r) => r._poRowId === badRow._poRowId);
		if (idx === -1) {
			return;
		}
		badData.splice(idx, 1);
		const doc = badRow.source_itemcode || badRow.stockid;
		if (doc && !goodLine.source_itemcode) {
			goodLine.source_itemcode = doc;
		}
		const goodData = [...(this.poDataSource['good']?.data || []), goodLine].sort(comparePoUploadQuantity).reverse();
		this.poDataSource['good'] = new MatTableDataSource(goodData);
		this.poDataSource['bad'] = new MatTableDataSource(badData);
		delete this.poManualMapStockId[badRow._poRowId];
		this.recalculatePoUploadPodataFromDataSources();
	}

	applyManualPoUnmatchedLine(badRow: any): void {
		this.assignPoUploadRowIds([badRow]);
		const rid = badRow._poRowId as number;
		const entered = String(this.poManualMapStockId[rid] ?? '')
			.trim();
		if (!entered) {
			this.globalSearchService.showNotification(
				'Enter the stock ID from your inventory (or manufacturer lookup if you used MFG columns on the sheet).',
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		const discount =
			typeof badRow.discount === 'number' && !isNaN(badRow.discount) ? badRow.discount : 0;
		const item = {
			stockid: entered,
			quantity: badRow.quantity,
			price: badRow.price === undefined || badRow.price === null || badRow.price === '' ? '' : badRow.price,
			description: badRow.description || '',
			discount,
			vendor: badRow.vendor || '',
			source_itemcode: badRow.source_itemcode || badRow.stockid,
		};
		this.poManualResolvingRowId = rid;
		this.purchasingservice
			.buildPoFromUpload({ items: [item], matchOnMfg: this.poLastUploadMatchOnMfg })
			.subscribe({
				next: (res: any) => {
					this.poManualResolvingRowId = null;
					if (res?.good?.length === 1) {
						this.mergeResolvedPoLineIntoGood(res.good[0], badRow);
						this.globalSearchService.showNotification(
							'Matched to ' + res.good[0].stockid,
							'success',
							'bottom',
							'right'
						);
					} else {
						this.globalSearchService.showNotification(
							'That value did not resolve to a stockmaster item.',
							'warning',
							'bottom',
							'right'
						);
					}
					this.cdr.markForCheck();
				},
				error: () => {
					this.poManualResolvingRowId = null;
					this.globalSearchService.showNotification(
						'Could not verify that line.',
						'danger',
						'bottom',
						'right'
					);
					this.cdr.markForCheck();
				},
			});
	}

	onPoImportTabChange(index: number): void {
		if (index === 0) {
			this.poPdfFile = null;
			this.poPdfDropzoneFiles = [];
		}
	}

	private readonly AI_ACCEPTED_EXTS = ['.pdf', '.jpg', '.jpeg', '.png', '.gif', '.webp', '.csv', '.xlsx', '.xls'];

	private acceptAiFile(f: File): boolean {
		const lower = f.name.toLowerCase();
		if (!this.AI_ACCEPTED_EXTS.some((ext) => lower.endsWith(ext))) {
			this.globalSearchService.showNotification(
				'Unsupported file type. Use PDF, image (JPG/PNG/GIF/WEBP), CSV, or XLSX.',
				'warning',
				'bottom',
				'right'
			);
			return false;
		}
		const maxBytes = 20971520; // 20 MB covers images; server enforces per-type limits
		if (f.size > maxBytes) {
			this.globalSearchService.showNotification('File must be 20 MB or smaller.', 'warning', 'bottom', 'right');
			return false;
		}
		return true;
	}

	onPoPdfDropzoneChange(event: NgxDropzoneChangeEvent): void {
		if (!event) {
			return;
		}
		if (event.rejectedFiles?.length) {
			const names = event.rejectedFiles.map((f) => f.name).join(', ');
			this.globalSearchService.showNotification(
				`Not added (type or size): ${names}`,
				'warning',
				'bottom',
				'right'
			);
		}
		if (!event.addedFiles?.length) {
			return;
		}
		if (event.addedFiles.length > 1) {
			this.globalSearchService.showNotification(
				'Only one file at a time — using the first file.',
				'info',
				'bottom',
				'right'
			);
		}
		const f = event.addedFiles[0];
		if (!this.acceptAiFile(f)) {
			return;
		}
		this.poPdfFile = f;
		this.poPdfDropzoneFiles = [f];
		this.upload_error = false;
		this.cdr.markForCheck();
	}

	onAiTabPaste(event: ClipboardEvent): void {
		if (!event.clipboardData) {
			return;
		}
		const items = Array.from(event.clipboardData.items);
		const imageItem = items.find((item) => item.type.startsWith('image/'));
		if (!imageItem) {
			return;
		}
		event.preventDefault();
		const blob = imageItem.getAsFile();
		if (!blob) {
			return;
		}
		const ext = '.' + (imageItem.type.split('/')[1] || 'png');
		const file = new File([blob], 'pasted-image' + ext, { type: imageItem.type });
		if (!this.acceptAiFile(file)) {
			return;
		}
		this.poPdfFile = file;
		this.poPdfDropzoneFiles = [file];
		this.upload_error = false;
		this.globalSearchService.showNotification('Image pasted from clipboard.', 'info', 'bottom', 'right');
		this.cdr.markForCheck();
	}

	onRemovePdfPo(file: File): void {
		this.poPdfDropzoneFiles = this.poPdfDropzoneFiles.filter((x) => x !== file);
		if (!this.poPdfDropzoneFiles.length) {
			this.poPdfFile = null;
		} else {
			this.poPdfFile = this.poPdfDropzoneFiles[0];
		}
	}

	extractPdfPoAndMatch(): void {
		if (!this.poPdfFile) {
			this.globalSearchService.showNotification('Add a file first.', 'info', 'bottom', 'right');
			return;
		}
		this.upload_error = false;
		this.processing_recs = true;

		const file = this.poPdfFile;
		const lower = file.name.toLowerCase();
		const isSpreadsheet = ['.csv', '.xlsx', '.xls'].some((ext) => lower.endsWith(ext));
		const isImage = ['.jpg', '.jpeg', '.png', '.gif', '.webp'].some((ext) => lower.endsWith(ext));

		const sendPayload = (payload: { source_type: string; file_base64?: string; text_content?: string }) => {
			this.purchasingservice.parsePoPdf(payload).subscribe({
				next: (res: any) => {
					if (!res?.success) {
						if (res?.diagnostic) {
							console.error('parsePoPdf diagnostic (full object):', res.diagnostic);
						}
						this.globalSearchService.showNotification(
							res?.message || 'AI extraction failed.',
							'danger',
							'bottom',
							'right'
						);
						this.processing_recs = false;
						this.cdr.markForCheck();
						return;
					}
					const lines = Array.isArray(res.lines) ? res.lines : [];
					if (!lines.length) {
						this.globalSearchService.showNotification('No line items found in document.', 'warning', 'bottom', 'right');
						this.processing_recs = false;
						this.cdr.markForCheck();
						return;
					}
					const lineInputs = lines
						.map((row: any) => {
							const code = String(row.itemcode || '').trim();
							const qty = Number(row.qty);
							const pr = row.price;
							let price: string | number = '';
							if (pr !== null && pr !== undefined && pr !== '') {
								const n = typeof pr === 'number' ? pr : parseFloat(String(pr).replace(/[^0-9.\-]/g, ''));
								price = isNaN(n) ? '' : n;
							}
							return {
								stockid: code,
								quantity: isFinite(qty) ? qty : 0,
								vendor: '',
								price,
								description: String(row.description || '').trim(),
								discount: 0,
								source_itemcode: code,
							};
						})
						.filter((li: any) => li.stockid && li.quantity);

					if (!lineInputs.length) {
						this.globalSearchService.showNotification(
							'No valid lines after extraction (need item code and quantity).',
							'warning',
							'bottom',
							'right'
						);
						this.processing_recs = false;
						this.cdr.markForCheck();
						return;
					}

					this.poLastUploadMatchOnMfg = false;
					const data = { items: lineInputs, matchOnMfg: false };
					this.purchasingservice.buildPoFromUpload(data).subscribe({
						next: (buildRes: any) => {
							this.poDataSource = {};
							this.uploadPodata = {
								items: [],
								lines: { good: 0, bad: 0 },
								units: { good: 0, bad: 0 },
							};
							if (buildRes['good']) {
								this.poDataSource['good'] = new MatTableDataSource(
									buildRes['good'].sort(comparePoUploadQuantity).reverse()
								);
								buildRes['good'].map((i: any) => {
									this.uploadPodata['lines']['good']++;
									this.uploadPodata['units']['good'] += Number(i.quantity);
								});
								this.uploadPodata['items'] = buildRes['good'];
							}
							if (buildRes['bad']) {
								this.assignPoUploadRowIds(buildRes['bad']);
								this.poDataSource['bad'] = new MatTableDataSource(
									buildRes['bad'].sort(comparePoUploadQuantity).reverse()
								);
								buildRes['bad'].map((i: any) => {
									this.uploadPodata['lines']['bad']++;
									this.uploadPodata['units']['bad'] += Number(i.quantity);
								});
							}
							this.poPdfReviewActive = true;
							this.vendors_detected = false;
							this.from_reorder = false;
							this.poReviewReady = true;
							this.processing_recs = false;
							this.cdr.markForCheck();
						},
						error: () => {
							this.processing_recs = false;
							this.globalSearchService.showNotification(
								'Could not match lines to inventory.',
								'danger',
								'bottom',
								'right'
							);
							this.cdr.markForCheck();
						},
					});
				},
				error: () => {
					this.processing_recs = false;
					this.globalSearchService.showNotification('AI extraction request failed.', 'danger', 'bottom', 'right');
					this.cdr.markForCheck();
				},
			});
		};

		const reader = new FileReader();
		reader.onerror = () => {
			this.processing_recs = false;
			this.globalSearchService.showNotification('Could not read file.', 'danger', 'bottom', 'right');
			this.cdr.markForCheck();
		};

		if (isSpreadsheet) {
			reader.onload = () => {
				try {
					const wb = XLSX.read(reader.result, { type: 'array' });
					const csv = XLSX.utils.sheet_to_csv(wb.Sheets[wb.SheetNames[0]]);
					sendPayload({ source_type: 'spreadsheet_text', text_content: csv });
				} catch {
					this.processing_recs = false;
					this.globalSearchService.showNotification('Could not parse spreadsheet.', 'danger', 'bottom', 'right');
					this.cdr.markForCheck();
				}
			};
			reader.readAsArrayBuffer(file);
		} else {
			reader.onload = () => {
				sendPayload({
					source_type: isImage ? 'image' : 'pdf',
					file_base64: String(reader.result || ''),
				});
			};
			reader.readAsDataURL(file);
		}
	}

	poUploadFieldLabel(type: string): string {
		return poUploadFieldTypeLabel(type, this.config?.env?.package === 'tires');
	}

	get poItemMappingBanner(): { type: 'error' | 'hint'; text: string } | null {
		if (!this.poUploadReady) {
			return null;
		}
		const id = poUploadResolveItemIdentification(this.poColumnMappings);
		if (id.ok === false) {
			return { type: 'error', text: id.error };
		}
		const hint = poItemIdentificationHint(this.poColumnMappings);
		return hint ? { type: 'hint', text: hint } : null;
	}

	uploadPo() {
		this.poPdfReviewActive = false;
		if (!poUploadHasRequiredMappings(this.poColumnMappings)) {
			this.globalSearchService.showNotification(
				'Map item identification (internal ID or manufacturer part) and order quantity.',
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		const id = poUploadResolveItemIdentification(this.poColumnMappings);
		if (id.ok === false) {
			this.globalSearchService.showNotification(id.error, 'warning', 'bottom', 'right');
			return;
		}
		const { items: lineInputs, skippedRows } = buildPoUploadLineInputs(this.poUploadedRawData, this.poColumnMappings);
		if (skippedRows > 0) {
			this.globalSearchService.showNotification(
				`${skippedRows} row(s) skipped — Brand is mapped but those rows have an empty brand or part.`,
				'info',
				'bottom',
				'right'
			);
		}
		if (!lineInputs.length) {
			this.globalSearchService.showNotification(
				'No order lines found (check quantities and mapped item / brand + part values).',
				'warning',
				'bottom',
				'right'
			);
			return;
		}

		this.uploadPodata = {
			items: [],
			lines: { good: 0, bad: 0 },
			units: { good: 0, bad: 0 }
		};

		this.upload_error = false;
		this.processing_recs = true;

		const vendors: string[] = [];
		lineInputs.forEach((li) => {
			if (li.vendor) {
				vendors.push(li.vendor);
			}
		});

		this.poLastUploadMatchOnMfg = getPoMatchOnMfgFromMappings(this.poColumnMappings);
		const data = {
			items: lineInputs,
			matchOnMfg: this.poLastUploadMatchOnMfg
		};
		this.purchasingservice.buildPoFromUpload(data).subscribe({
			next: (res) => {
				this.poDataSource = {};

				if (res['good']) {
					this.poDataSource['good'] = new MatTableDataSource(res['good'].sort(comparePoUploadQuantity).reverse());
					res['good'].map((i) => {
						this.uploadPodata['lines']['good']++;
						this.uploadPodata['units']['good'] += Number(i.quantity);
					});
					this.uploadPodata['items'] = res['good'];
				}

				if (res['bad']) {
					this.assignPoUploadRowIds(res['bad']);
					this.poDataSource['bad'] = new MatTableDataSource(res['bad'].sort(comparePoUploadQuantity).reverse());
					res['bad'].map((i) => {
						this.uploadPodata['lines']['bad']++;
						this.uploadPodata['units']['bad'] += Number(i.quantity);
					});
				}

				this.vendors_detected = Array.from(new Set(vendors.filter((i) => { return i !== undefined && i !== ''; }))).join(',');

				if (this.vendors_detected != '') {
					this.from_reorder = true;
				} else {
					this.from_reorder = false;
				}
				this.poReviewReady = true;
				this.processing_recs = false;
			},
			error: () => {
				this.processing_recs = false;
				this.globalSearchService.showNotification('Could not match lines to inventory.', 'danger', 'bottom', 'right');
			},
		});
	}

	buildPO() {
		if (this.vendors_detected != this.customer.supplierid && this.from_reorder) {
			if (confirm('Vendor selected does not match vendors from upload, continue?')) {
				this.addItem.emit(this.uploadPodata['items'])
				this.files = [];
				this.resetUploadPo();
				this.modalService.dismissAll();
				this.flipToReview.emit();
			}
		} else {
			this.addItem.emit(this.uploadPodata['items']);
			this.files = [];
			this.resetUploadPo();
			this.modalService.dismissAll();
			this.flipToReview.emit();
		}
	}

	clearPoSpreadsheetParseState(): void {
		this.poUploadedRawData = [];
		this.poUploadedHeaders = [];
		this.poColumnMappings = {};
		this.poUploadReady = false;
	}

	clearPoSpreadsheetAll(): void {
		this.files = [];
		this.poActiveFile = null;
		this.poExcelWorkbook = null;
		this.poSheetNames = [];
		this.poSelectedSheetName = '';
		this.poHeaderRowNumber = 1;
		this.poShowParseOptions = false;
		this.clearPoSpreadsheetParseState();
		this.upload_error = false;
	}

	/** Leave file + column mapping; step back from recognized/unrecognized review. */
	resetPoReviewResults(): void {
		this.poReviewReady = false;
		this.processing_recs = false;
		this.vendors_detected = false;
		this.poDataSource = false;
		this.poPdfReviewActive = false;
		this.poManualMapStockId = {};
		this.poManualResolvingRowId = null;
	}

	resetUploadPo() {
		this.resetPoReviewResults();
		this.clearPoSpreadsheetAll();
		this.poImportTabIndex = 0;
		this.poPdfFile = null;
		this.poPdfDropzoneFiles = [];
		this.poPdfReviewActive = false;
		this.poUploadRowIdSeq = 0;
		this.poManualMapStockId = {};
		this.poLastUploadMatchOnMfg = false;
		this.poManualResolvingRowId = null;
	}

	toggleUploadHelp() {
		this.poHelp = this.poHelp == true ? false : true;
	}

	onPoDropzoneChange(event: NgxDropzoneChangeEvent): void {
		if (!event) {
			return;
		}
		if (event.rejectedFiles?.length) {
			const names = event.rejectedFiles.map((f) => f.name).join(', ');
			this.globalSearchService.showNotification(
				`Not added (type or size): ${names}`,
				'warning',
				'bottom',
				'right'
			);
		}
		if (!event.addedFiles?.length) {
			return;
		}
		const f = event.addedFiles[0];
		const lower = f.name.toLowerCase();
		if (!PO_UPLOAD_ALLOWED_EXTENSIONS.some((ext) => lower.endsWith(ext))) {
			this.globalSearchService.showNotification(
				`Use CSV or Excel only: ${f.name}`,
				'warning',
				'bottom',
				'right'
			);
			return;
		}
		if (event.addedFiles.length > 1) {
			this.globalSearchService.showNotification(
				'Only one file at a time — using the first file.',
				'info',
				'bottom',
				'right'
			);
		}

		this.clearPoSpreadsheetParseState();
		this.poActiveFile = f;
		this.files = [f];
		this.poShowParseOptions = true;
		this.poHeaderRowNumber = 1;
		this.upload_error = false;

		if (lower.endsWith('.xlsx') || lower.endsWith('.xls')) {
			this.processing_recs = true;
			readFileAsArrayBuffer(f)
				.then((buf) => {
					try {
						this.poExcelWorkbook = XLSX.read(buf, { type: 'array', cellDates: true, dense: false });
						this.poSheetNames = [...(this.poExcelWorkbook.SheetNames || [])];
						this.poSelectedSheetName = this.poSheetNames[0] || '';
					} catch {
						this.globalSearchService.showNotification(
							'Could not read that Excel file.',
							'danger',
							'bottom',
							'right'
						);
						this.clearPoSpreadsheetAll();
					}
					this.processing_recs = false;
					this.cdr.markForCheck();
				})
				.catch(() => {
					this.processing_recs = false;
					this.globalSearchService.showNotification('Could not read file.', 'danger', 'bottom', 'right');
					this.clearPoSpreadsheetAll();
					this.cdr.markForCheck();
				});
		} else {
			this.poExcelWorkbook = null;
			this.poSheetNames = [];
			this.poSelectedSheetName = '';
			this.processing_recs = false;
		}
	}

	onRemove(event: File): void {
		this.files = this.files.filter((x) => x !== event);
		if (!this.files.length) {
			this.clearPoSpreadsheetAll();
		} else {
			this.upload_error = false;
		}
	}

	parsePoSpreadsheetForPoModal(): void {
		if (!this.poActiveFile) {
			this.globalSearchService.showNotification('Add a file first.', 'info', 'bottom', 'right');
			return;
		}
		const lower = this.poActiveFile.name.toLowerCase();
		if ((lower.endsWith('.xlsx') || lower.endsWith('.xls')) && !this.poSelectedSheetName) {
			this.globalSearchService.showNotification('Pick a sheet to import.', 'warning', 'bottom', 'right');
			return;
		}

		this.processing_recs = true;
		this.clearPoSpreadsheetParseState();

		void parsePoUploadSpreadsheet({
			file: this.poActiveFile,
			workbook: this.poExcelWorkbook,
			selectedSheetName: this.poSelectedSheetName,
			headerRowNumber: this.poHeaderRowNumber,
		}).then((res) => {
			if ('error' in res) {
				const msg =
					res.error === 'reload_excel'
						? 'Reload the Excel file.'
						: res.error === 'sheet_not_found'
							? 'That sheet was not found in the workbook.'
							: res.error === 'csv_empty'
								? 'CSV appears empty.'
								: res.error === 'bad_extension'
									? 'Unsupported file type.'
									: 'Could not parse file.';
				this.globalSearchService.showNotification(msg, res.error === 'parse_failed' ? 'danger' : 'warning', 'bottom', 'right');
				this.processing_recs = false;
				this.cdr.markForCheck();
				return;
			}

			this.poUploadedRawData = res.rows;
			this.poUploadedHeaders = res.rows.length > 0 ? Object.keys(res.rows[0]) : [];
			this.poUploadedHeaders.forEach((h) => {
				if (this.poColumnMappings[h] === undefined) {
					this.poColumnMappings[h] = 'ignore';
				}
			});
			applyGreedyPoAutoMap(this.poUploadedHeaders, this.poColumnMappings, this.poAvailableFieldTypes);
			this.poUploadReady = res.rows.length > 0;
			if (!res.rows.length) {
				this.globalSearchService.showNotification(
					'No data rows after the header row. Try a higher header row # if titles are not on row 1.',
					'warning',
					'bottom',
					'right'
				);
			}
			this.processing_recs = false;
			this.cdr.markForCheck();
		});
	}
	
	open_po_grid() {
	
	const data = {'loccode': this.user.value.user.defaultlocation.loccode, 'supplierno': this.customer.supplierid};
	this.purchasingservice.getGridList(data).subscribe(r => {
	
		this.griditems = r;
		this.modalService.open(this.gridporef, { ariaLabelledBy: 'modal-title', size: 'xl' }).result.then((result) => {
		
		}, (reason) => {
		});
		});
	}
	addGridItems() {
			let submit = [];
			this.griditems.forEach((item: any) => {
			if(item.quantity > 0){
			item['price'] = item['unitprice'];
			submit.push(item);
			}
			})
			this.addItem.emit(submit);
			this.modalService.dismissAll();
			this.flipToReview.emit();		
	}
	
	decrementgrid(item: any) {
		const index = this.griditems.indexOf(item);
			if (this.griditems[index].quantity > 0) {
				this.griditems[index].quantity -= 1;
			}
	}
	
	toggleGridDetail(){
		if(this.showdetail == true){
		this.showdetail = false;
		} else {
		this.showdetail = true;
		}
	}
	incrementgrid(item: any) {
		const index = this.griditems.indexOf(item);
		this.griditems[index].quantity += 1;
	}
	updateGridQuantity(event: any, item: any) {
		const index = this.griditems.indexOf(item);
		this.griditems[index].quantity = event.target.value;
	}

	handleMouseDown(event: MouseEvent) {
		event.stopPropagation();
	}

	cleanAndFormatHTML(htmlContent: string): string {
		if (!htmlContent) {
			return '';
		}
		// Clean up the HTML content
		const cleanedHTML = htmlContent
			// Remove excessive white spaces
			.replace(/\s{2,}/g, ' ')
			// Remove extra line breaks
			.replace(/\n\s*\n/g, '\n')
			// Trim leading and trailing white spaces
			.trim();

		// Format the HTML content nicely
		let formattedHTML = '';
		const parser = new DOMParser();
		const doc = parser.parseFromString(cleanedHTML, 'text/html');
		if (doc.body) {
			formattedHTML = doc.body.innerHTML;
		}

		return formattedHTML;
	}

	emitaddItem(event: any) {
		this.addItem.emit(event);
	}

	handleEnterRec(event: any) {

		this.itemSearchForm.get('keywords').setValue('');
		this.focusKeywordsInput();

	}

	emitaddMix(event: any) {
		this.addMix.emit(event);
	}

	emitaddEdu(event:any) {
		this.addEdu.emit(event);
	}
	emitUpdateCart(event:any) {
		this.updateCart.emit(event);
	}

	toggleGridView() {
		this.isGridView = !this.isGridView;
	}

	addBuy() {
		if (!this.config?.buyfive) {
			return;
		}
		const item = [{ 'stockid': 'BUY5', 'description': 'BUY 5 GET 1', 'mbflag': 'B', 'lineid': 'MUB', 'longdescription': 'BUY 5 GET 1', 'units': 'each', 'image': '', 'taxcatid': '2', 'fetvalue': '0.00', 'decimalplaces': '0', 'mfgpart': 'BUY5', 'price': '0.00', 'manufacturer_id': '263', 'brand': 'SURFACE', 'total_available': 0, 'qty': 0, 'qty1': null, 'qty2': null, 'qty3': null, 'sort_group': '0', 'stocked': '1', 'max_credit': 0, 'fullprice': '0.00', 'quantity': 1, 'discount': 0, 'hasdiscount': false, 'thumb': 'https://sandbox.wnytireco.com/image/cached/no_image-50x50.png', 'image_large': 'https://sandbox.wnytireco.com/image/cached/no_image-850x850.png', 'locqoh': '0', 'ispromo': false, 'qoo': 0, 'qos': 0 }]

		this.addItem.emit(item);
	}

	addBuy6() {
		if (!this.config?.buysix) {
			return;
		}
		const item = [{ 'stockid': 'BUY6', 'description': 'BUY 6 GET 1', 'mbflag': 'B', 'lineid': 'MUB', 'longdescription': 'BUY 6 GET 1', 'units': 'each', 'image': '', 'taxcatid': '2', 'fetvalue': '0.00', 'decimalplaces': '0', 'mfgpart': 'BUY6', 'price': '0.00', 'manufacturer_id': '263', 'brand': 'SURFACE', 'total_available': 0, 'qty': 0, 'qty1': null, 'qty2': null, 'qty3': null, 'sort_group': '0', 'stocked': '1', 'max_credit': 0, 'fullprice': '0.00', 'quantity': 1, 'discount': 0, 'hasdiscount': false, 'thumb': 'https://sandbox.wnytireco.com/image/cached/no_image-50x50.png', 'image_large': 'https://sandbox.wnytireco.com/image/cached/no_image-850x850.png', 'locqoh': '0', 'ispromo': false, 'qoo': 0, 'qos': 0 }]

		this.addItem.emit(item);
	}

	clearSearchedFor(){
		this.itemSearchForm.get('keywords').setValue('');
	}

	// Speech Recognition Methods
	toggleVoiceListening(): void {
		if (this.isVoiceSearching) {
			// User is stopping - just stop listening, each phrase already searched automatically
			this.stopVoiceSearch();
		} else {
			// Enable voice search preference when user starts using it
			if (!this.enableVoiceSearch) {
				this.enableVoiceSearch = true;
				localStorage.setItem('itemSearchVoiceEnabled', 'true');
			}
			this.startVoiceSearch();
		}
	}

	startVoiceSearch(): void {
		if (!this.speechRecognitionService.getIsSupported()) {
			return;
		}

		// Clean up any existing subscriptions first
		if (this.voiceSearchSubscription || this.voiceErrorSubscription || this.voiceListeningSubscription) {
			this.stopVoiceSearch();
		}

		// Clear the search field for new input
		this.itemSearchForm.get('keywords').setValue('');

		// Request microphone permission first (this will trigger the browser permission dialog)
		this.speechRecognitionService.requestMicrophonePermission().then(hasPermission => {
			if (!hasPermission) {
				this.isVoiceSearching = false;
				this.globalSearchService.showNotification(
					'Microphone permission is required for voice search.',
					'error',
					'bottom',
					'right'
				);
				return;
			}

			// Small delay to ensure service is fully stopped and ready for restart
			setTimeout(() => {
				// Enable continuous mode so it keeps listening after each phrase
				this.speechRecognitionService.setContinuous(true);

				// Subscribe to speech recognition results
				this.voiceSearchSubscription = this.speechRecognitionService.result$.subscribe(
					(result: SpeechRecognitionResult | null) => {
						if (result && result.transcript.trim()) {
							if (result.isFinal) {
								// Final result - speech naturally ended (silence detected by API)
								// Each phrase triggers its own search
								const searchTerm = result.transcript.trim();
								this.itemSearchForm.get('keywords').setValue(searchTerm);
								// Trigger search immediately for this phrase
								this.itemSearch();
								// Keep listening for next phrase (continuous mode)
							} else {
								// Interim result - just show the current phrase being spoken
								this.itemSearchForm.get('keywords').setValue(result.transcript.trim());
							}
						}
					}
				);

				// Subscribe to errors
				this.voiceErrorSubscription = this.speechRecognitionService.error$.subscribe(
					(error) => {
						if (error) {
							console.error('Voice search error:', error);
							this.stopVoiceSearch();
							this.globalSearchService.showNotification(
								error.message || 'Voice search failed',
								'error',
								'bottom',
								'right'
							);
						}
					}
				);

				// Subscribe to listening state
				this.voiceListeningSubscription = this.speechRecognitionService.isListening$.subscribe(
					(listening) => {
						this.isVoiceSearching = listening;
					}
				);

				// Start listening after permission is granted
				this.speechRecognitionService.startListening().catch((error) => {
					console.error('Failed to start voice search:', error);
					this.isVoiceSearching = false;
					this.globalSearchService.showNotification(
						'Failed to start voice search. Please check microphone permissions.',
						'error',
						'bottom',
						'right'
					);
				});
			}, 100); // Small delay to ensure clean state transition
		}).catch((error) => {
			console.error('Permission request failed:', error);
			this.isVoiceSearching = false;
			this.globalSearchService.showNotification(
				'Failed to request microphone permission.',
				'error',
				'bottom',
				'right'
			);
		});
	}

	stopVoiceSearch(): void {
		if (this.voiceSearchSubscription) {
			this.voiceSearchSubscription.unsubscribe();
			this.voiceSearchSubscription = null;
		}
		if (this.voiceErrorSubscription) {
			this.voiceErrorSubscription.unsubscribe();
			this.voiceErrorSubscription = null;
		}
		if (this.voiceListeningSubscription) {
			this.voiceListeningSubscription.unsubscribe();
			this.voiceListeningSubscription = null;
		}
		this.speechRecognitionService.stopListening();
		this.speechRecognitionService.setContinuous(false); // Reset to non-continuous mode
		this.isVoiceSearching = false;
	}

	// Sort functionality methods
	getSortStorageKey(): string {
		const packageName = this.config?.env?.package || 'default';
		const clientName = this.config?.env?.client || 'default';
		return `itemSearchSort_${packageName}_${clientName}`;
	}

	loadSortState(): void {
		try {
			const storageKey = this.getSortStorageKey();
			const savedState = localStorage.getItem(storageKey);
			if (savedState) {
				const state = JSON.parse(savedState);
				if (state.column && state.direction) {
					this.sortColumn = state.column;
					this.sortDirection = state.direction;
				}
			}
		} catch (error) {
			console.error('Failed to load sort state:', error);
		}
	}

	saveSortState(): void {
		try {
			const storageKey = this.getSortStorageKey();
			const state = {
				column: this.sortColumn,
				direction: this.sortDirection
			};
			localStorage.setItem(storageKey, JSON.stringify(state));
		} catch (error) {
			console.error('Failed to save sort state:', error);
		}
	}

	sortItems(column: string): void {
		// If clicking the same column, toggle direction
		if (this.sortColumn === column) {
			this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
		} else {
			// If clicking a different column, set it as sort column with 'asc' direction
			this.sortColumn = column;
			this.sortDirection = 'asc';
		}

		// Apply the sort
		this.applySort();

		// Save sort state
		this.saveSortState();
	}

	applySort(): void {
		if (!this.sortColumn || !this.filtered_items || this.filtered_items.length === 0) {
			return;
		}

		const sortedItems = [...this.filtered_items].sort((a: any, b: any) => {
			let aValue = this.getSortValue(a, this.sortColumn);
			let bValue = this.getSortValue(b, this.sortColumn);

			if (aValue == null) {aValue = '';}
			if (bValue == null) {bValue = '';}

			if (this.sortColumn === 'price' || this.sortColumn === 'quantity') {
				const aNum = parseFloat(aValue) || 0;
				const bNum = parseFloat(bValue) || 0;
				const comparison = aNum - bNum;
				return this.sortDirection === 'asc' ? comparison : -comparison;
			}

			const aStr = String(aValue).toLowerCase();
			const bStr = String(bValue).toLowerCase();
			let comparison = 0;
			if (aStr > bStr) {
				comparison = 1;
			} else if (aStr < bStr) {
				comparison = -1;
			}

			return this.sortDirection === 'asc' ? comparison : -comparison;
		});

		this.filtered_items = sortedItems;
	}

	getSortValue(item: any, column: string): any {
		if (column.startsWith('description_')) {
			const lang = column.replace('description_', '');
			if (item.descriptions && item.descriptions[lang]) {
				return item.descriptions[lang];
			}
			if (item.descriptions && item.descriptions.description && typeof item.descriptions.description === 'object' && item.descriptions.description[lang]) {
				return item.descriptions.description[lang];
			}
			if (item[column]) {
				return item[column];
			}
			return item.description || '';
		}

		return item[column];
	}

	getSortableColumns(): any[] {
		if (this.config && this.config.sortableColumns) {
			return Object.keys(this.config.sortableColumns)
				.filter(key => {
					// Filter out language-specific description columns
					if (key === 'description_en' || key === 'description_fr') {
						return false;
					}
					return this.config.sortableColumns[key].enabled;
				})
				.map(key => ({
					key: key,
					label: this.config.sortableColumns[key].label,
					columnClass: this.config.sortableColumns[key].columnClass
				}));
		}

		return [];
	}

	getSortIcon(column: string): string {
		if (this.sortColumn === column) {
			return this.sortDirection === 'asc' ? 'arrow_upward' : 'arrow_downward';
		}
		return 'sort';
	}

	getTemplateHeaderLayout(): any[] {
		if (!this.config || !this.config.sortableColumns || !this.filtered_items.length) {
			return [];
		}

		const packageType = this.config.env?.package;
		const isSalesman = this.issalesman;
		const isLiveInventory = this.config.liveinventory;
		const showFilters = this.showfilters;

		if (packageType === 'beauty') {
			if (isSalesman) {
				return this.getSalesmanTemplateHeaders();
			} else if (isLiveInventory) {
				return this.getBeautyWqohTemplateHeaders(showFilters);
			} else {
				return this.getBeautyTemplateHeaders(showFilters);
			}
		} else if (packageType === 'tires') {
			return this.getTiresTemplateHeaders(showFilters);
		}

		return [];
	}

	getBeautyTemplateHeaders(showFilters: boolean): any[] {
		const stockIdCol = showFilters ? 'col-md-2 col-lg-1 col-xl-1' : 'col-md-2 col-lg-1';
		const descCol = showFilters ? 'col-md-2 col-lg-2 col-xl-1' : 'col-md-2 col-lg-2';

		return [
			{
				columnClass: 'col-12 text-center col-md-2 col-lg-auto',
				sortable: false,
				label: '',
				key: '',
				align: 'center'
			},
			{
				columnClass: stockIdCol,
				sortable: true,
				label: 'Stock ID',
				key: 'stockid',
				align: 'left'
			},
			{
				columnClass: descCol,
				sortable: true,
				label: 'Description',
				key: 'description',
				align: 'left'
			},
			{
				columnClass: 'col-12 col-md-5 col-lg-2 col-xl-3',
				sortable: true,
				label: 'Price',
				key: 'price',
				align: 'right'
			},
			{
				columnClass: 'col-12 col-md-6 col-lg-3',
				sortable: false,
				label: '',
				key: '',
				align: 'left'
			},
			{
				columnClass: 'col-6 col-md-6 col-lg-1',
				sortable: false,
				label: '',
				key: '',
				align: 'right'
			}
		];
	}

	getBeautyWqohTemplateHeaders(showFilters: boolean): any[] {
		const qohCol = showFilters ? 'col-md-4 col-lg-2 col-xl-1' : 'col-md-4 col-lg-2';
		const stockIdCol = 'col-md-1 col-lg-1';
		const descCol = 'col-md-2 col-lg-1';

		return [
			{
				columnClass: 'col-12 col-md-2 col-lg-1',
				sortable: false,
				label: '',
				key: '',
				align: 'center'
			},
			{
				columnClass: stockIdCol,
				sortable: true,
				label: 'Stock ID',
				key: 'stockid',
				align: 'left'
			},
			{
				columnClass: descCol,
				sortable: true,
				label: 'Description',
				key: 'description',
				align: 'left'
			},
			{
				columnClass: qohCol,
				sortable: false,
				label: 'QOH / COMM / AVAIL',
				key: '',
				align: 'center'
			},
			{
				columnClass: 'col-md-3 col-lg-2',
				sortable: true,
				label: 'Price',
				key: 'price',
				align: 'right'
			},
			{
				columnClass: 'col-md-3 col-lg-2',
				sortable: false,
				label: '',
				key: '',
				align: 'left'
			},
			{
				columnClass: 'col-6 col-md-6 col-lg-1',
				sortable: false,
				label: '',
				key: '',
				align: 'right'
			}
		];
	}

	getSalesmanTemplateHeaders(): any[] {
		return [
			{
				columnClass: 'col-md-2 col-lg-3',
				sortable: true,
				label: 'Stock ID',
				key: 'stockid',
				align: 'left'
			},
			{
				columnClass: 'col-md-3 col-lg-3',
				sortable: true,
				label: 'Description',
				key: 'description',
				align: 'left'
			},
			{
				columnClass: 'col-12 col-sm-1 col-md-1 col-lg-1',
				sortable: false,
				label: '',
				key: '',
				align: 'center'
			},
			{
				columnClass: 'col-12 col-md-3',
				sortable: false,
				label: '',
				key: '',
				align: 'left'
			},
			{
				columnClass: 'col-6 col-md-2 col-lg-1',
				sortable: false,
				label: '',
				key: '',
				align: 'right'
			}
		];
	}

	getTiresTemplateHeaders(showFilters: boolean): any[] {
		const qohCol = showFilters ? 'col-md-6' : 'col-md-5';

		return [
			{
				columnClass: showFilters ? 'col-md-3' : 'col-md-3',
				sortable: true,
				label: 'Stock ID',
				key: 'stockid',
				align: 'left'
			},
			{
				columnClass: showFilters ? 'col-md-3' : 'col-md-4',
				sortable: true,
				label: 'Description',
				key: 'description',
				align: 'left'
			},
			{
				columnClass: qohCol,
				sortable: false,
				label: 'QOH / COMM / AVAIL / ON PO / EXT',
				key: '',
				align: 'center'
			}
		];
	}

	onSortDropdownChange(): void {
		// Clear header sort when dropdown sort changes (server-side sort takes precedence)
		if (this.sortColumn) {
			this.sortColumn = '';
			this.sortDirection = 'asc';
			this.saveSortState();
		}
		// Trigger search with new dropdown sort
		this.itemSearch();
	}

	ngOnDestroy(): void {
		if (this.inventorysearching) {
			this.inventorysearching.unsubscribe();
		}
		if (this.locationSubscription) {
			this.locationSubscription.unsubscribe();
		}

		// Clean up voice search subscriptions
		this.stopVoiceSearch();
	}

}
